// Путь: D:\QR\QR-WEB\dashboard\src\components\Admin\AdminDary\AdminDaryUsers.jsx
// Название: Admin DARY Users Management
// Версия: 2.0.0
// Дата: 28.01.2026

import React, { useState, useEffect } from 'react';
import './AdminDaryUniversal.css';

const API_URL = 'https://qr-money.onrender.com/api';

const AdminDaryUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('balance_desc');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ total: 0, pages: 1 });
  
  // Modal states
  const [modalType, setModalType] = useState(null); // 'details', 'bonus', 'push'
  const [selectedUser, setSelectedUser] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  
  // Actions
  const [bonusAmount, setBonusAmount] = useState('');
  const [bonusReason, setBonusReason] = useState('');
  const [pushTitle, setPushTitle] = useState('');
  const [pushBody, setPushBody] = useState('');
  const [message, setMessage] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);

  const token = localStorage.getItem('authToken');

  useEffect(() => {
    loadUsers();
  }, [page, sort]);

  const loadUsers = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({ page, limit: 20, sort, search });
      const res = await fetch(`${API_URL}/admin/dary/users?${params}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setUsers(data.data.users);
        setPagination(data.data.pagination);
      }
    } catch (err) {
      console.error('Load users error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    loadUsers();
  };

  const openModal = async (type, user) => {
    setSelectedUser(user);
    setModalType(type);
    setBonusAmount('');
    setBonusReason('');
    setPushTitle('');
    setPushBody('');
    
    if (type === 'details') {
      try {
        const res = await fetch(`${API_URL}/admin/dary/users/${user.id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) setUserDetails(data.data);
      } catch (err) {
        console.error('Load user details error:', err);
      }
    }
  };

  const closeModal = () => {
    setModalType(null);
    setSelectedUser(null);
    setUserDetails(null);
  };

  const addBonus = async () => {
    if (!selectedUser || !bonusAmount || parseFloat(bonusAmount) <= 0) {
      setMessage({ type: 'error', text: 'Укажите корректную сумму' });
      return;
    }

    setActionLoading(true);
    try {
      const res = await fetch(`${API_URL}/admin/dary/users/${selectedUser.id}/add-bonus`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ amount: parseFloat(bonusAmount), reason: bonusReason })
      });
      const data = await res.json();
      if (data.success) {
        setMessage({ type: 'success', text: `✅ Начислено ${bonusAmount} DAR для ${selectedUser.email}` });
        closeModal();
        loadUsers();
      } else {
        setMessage({ type: 'error', text: data.error });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Ошибка сети' });
    } finally {
      setActionLoading(false);
    }
  };

  const sendPush = async () => {
    if (!selectedUser || !pushTitle || !pushBody) {
      setMessage({ type: 'error', text: 'Заполните заголовок и текст' });
      return;
    }

    setActionLoading(true);
    try {
      const res = await fetch(`${API_URL}/admin/dary/users/${selectedUser.id}/send-push`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ title: pushTitle, body: pushBody })
      });
      const data = await res.json();
      if (data.success) {
        setMessage({ type: 'success', text: `✅ Push отправлен ${selectedUser.email}` });
        closeModal();
      } else {
        setMessage({ type: 'error', text: data.error });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Ошибка сети' });
    } finally {
      setActionLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('ru-RU', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });
  };

  return (
    <div className="adu-page">
      {/* Header */}
      <div className="adu-header">
        <h1>👥 DARY Юзеры</h1>
        <p>Всего: {pagination.total} пользователей DARY Universal</p>
      </div>

      {/* Message */}
      {message && (
        <div className={`adu-message adu-message-${message.type}`}>
          {message.text}
          <button onClick={() => setMessage(null)}>✕</button>
        </div>
      )}

      {/* Controls */}
      <div className="adu-controls-row">
        <form onSubmit={handleSearch} className="adu-search-form">
          <input
            type="text"
            placeholder="Поиск по email, имени..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button type="submit">🔍 Найти</button>
        </form>
        
        <select value={sort} onChange={(e) => { setSort(e.target.value); setPage(1); }}>
          <option value="balance_desc">По балансу ↓</option>
          <option value="balance_asc">По балансу ↑</option>
          <option value="joined_desc">По дате ↓</option>
          <option value="joined_asc">По дате ↑</option>
        </select>
      </div>

      {/* Table */}
      {loading ? (
        <div className="adu-loading">Загрузка...</div>
      ) : (
        <>
          <div className="adu-table-container">
            <table className="adu-table-full">
              <thead>
                <tr>
                  <th style={{width: '60px'}}>ID</th>
                  <th style={{width: '200px'}}>Email</th>
                  <th style={{width: '120px'}}>Имя</th>
                  <th style={{width: '100px'}}>Баланс</th>
                  <th style={{width: '100px'}}>Рефералов</th>
                  <th style={{width: '90px'}}>Активаций</th>
                  <th style={{width: '110px'}}>Дата</th>
                  <th style={{width: '200px'}}>Действия</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id}>
                    <td className="adu-td-center">#{user.id}</td>
                    <td>{user.email}</td>
                    <td>{user.first_name || '-'} {user.last_name || ''}</td>
                    <td className="adu-td-balance">
                      {parseFloat(user.dary_balance).toFixed(2)} DAR
                    </td>
                    <td className="adu-td-center">
                      {user.dary_referrals_count}
                      <span className="adu-text-muted"> ({user.dary_referrals_activated}✅)</span>
                    </td>
                    <td className="adu-td-center">{user.total_activations}</td>
                    <td className="adu-td-center">{formatDate(user.dary_joined_at)}</td>
                    <td className="adu-td-actions">
                      <button 
                        className="adu-action-btn adu-action-bonus"
                        onClick={() => openModal('bonus', user)}
                        title="Начислить бонус"
                      >
                        💰 Бонус
                      </button>
                      <button 
                        className="adu-action-btn adu-action-push"
                        onClick={() => openModal('push', user)}
                        title="Отправить Push"
                      >
                        📱
                      </button>
                      <button 
                        className="adu-action-btn adu-action-view"
                        onClick={() => openModal('details', user)}
                        title="Детали"
                      >
                        👁️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {pagination.pages > 1 && (
            <div className="adu-pagination">
              <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}>← Назад</button>
              <span>Страница {page} из {pagination.pages}</span>
              <button disabled={page >= pagination.pages} onClick={() => setPage(p => p + 1)}>Вперёд →</button>
            </div>
          )}
        </>
      )}

      {/* Modal Overlay */}
      {modalType && (
        <div className="adu-modal-overlay" onClick={closeModal}>
          <div className="adu-modal" onClick={e => e.stopPropagation()}>
            
            {/* Bonus Modal */}
            {modalType === 'bonus' && (
              <>
                <div className="adu-modal-header">
                  <h3>💰 Начислить бонус</h3>
                  <button onClick={closeModal}>✕</button>
                </div>
                <div className="adu-modal-body">
                  <div className="adu-modal-user">
                    <strong>{selectedUser?.email}</strong>
                    <span>Текущий баланс: {parseFloat(selectedUser?.dary_balance || 0).toFixed(2)} DAR</span>
                  </div>
                  <div className="adu-modal-form">
                    <input 
                      type="number" 
                      placeholder="Сумма DAR"
                      value={bonusAmount}
                      onChange={(e) => setBonusAmount(e.target.value)}
                      autoFocus
                    />
                    <input 
                      type="text" 
                      placeholder="Причина (опционально)"
                      value={bonusReason}
                      onChange={(e) => setBonusReason(e.target.value)}
                    />
                  </div>
                </div>
                <div className="adu-modal-footer">
                  <button className="adu-modal-btn-cancel" onClick={closeModal}>Отмена</button>
                  <button className="adu-modal-btn-primary" onClick={addBonus} disabled={actionLoading}>
                    {actionLoading ? 'Загрузка...' : '💰 Начислить'}
                  </button>
                </div>
              </>
            )}

            {/* Push Modal */}
            {modalType === 'push' && (
              <>
                <div className="adu-modal-header">
                  <h3>📱 Отправить Push</h3>
                  <button onClick={closeModal}>✕</button>
                </div>
                <div className="adu-modal-body">
                  <div className="adu-modal-user">
                    <strong>{selectedUser?.email}</strong>
                  </div>
                  <div className="adu-modal-form">
                    <input 
                      type="text" 
                      placeholder="Заголовок"
                      value={pushTitle}
                      onChange={(e) => setPushTitle(e.target.value)}
                      autoFocus
                    />
                    <textarea 
                      placeholder="Текст сообщения"
                      value={pushBody}
                      onChange={(e) => setPushBody(e.target.value)}
                      rows={3}
                    />
                  </div>
                </div>
                <div className="adu-modal-footer">
                  <button className="adu-modal-btn-cancel" onClick={closeModal}>Отмена</button>
                  <button className="adu-modal-btn-blue" onClick={sendPush} disabled={actionLoading}>
                    {actionLoading ? 'Загрузка...' : '📱 Отправить'}
                  </button>
                </div>
              </>
            )}

            {/* Details Modal */}
            {modalType === 'details' && (
              <>
                <div className="adu-modal-header">
                  <h3>👤 Детали пользователя</h3>
                  <button onClick={closeModal}>✕</button>
                </div>
                <div className="adu-modal-body">
                  {userDetails ? (
                    <div className="adu-details-grid">
                      <div className="adu-details-section">
                        <h4>📋 Информация</h4>
                        <div className="adu-details-row"><span>ID:</span><strong>#{userDetails.user.id}</strong></div>
                        <div className="adu-details-row"><span>Email:</span><strong>{userDetails.user.email}</strong></div>
                        <div className="adu-details-row"><span>Имя:</span><strong>{userDetails.user.first_name} {userDetails.user.last_name}</strong></div>
                        <div className="adu-details-row"><span>Телефон:</span><strong>{userDetails.user.phone || '-'}</strong></div>
                        <div className="adu-details-row"><span>Роль:</span><strong>{userDetails.user.role}</strong></div>
                      </div>
                      
                      <div className="adu-details-section">
                        <h4>💰 DARY Баланс</h4>
                        <div className="adu-details-row"><span>Текущий:</span><strong className="adu-highlight">{parseFloat(userDetails.user.dary_balance || 0).toFixed(2)} DAR</strong></div>
                        <div className="adu-details-row"><span>Получено:</span><strong>{parseFloat(userDetails.user.total_received || 0).toFixed(2)} DAR</strong></div>
                        <div className="adu-details-row"><span>Потрачено:</span><strong>{parseFloat(userDetails.user.total_spent || 0).toFixed(2)} DAR</strong></div>
                      </div>

                      {userDetails.dary_referrals.length > 0 && (
                        <div className="adu-details-section adu-details-full">
                          <h4>🔗 DARY Рефералы ({userDetails.dary_referrals.length})</h4>
                          <div className="adu-tags">
                            {userDetails.dary_referrals.map(ref => (
                              <span key={ref.id} className={`adu-tag adu-tag-${ref.status}`}>
                                {ref.short_code} ({ref.status})
                              </span>
                            ))}
                          </div>
                        </div>
                      )}

                      {userDetails.all_balances.length > 0 && (
                        <div className="adu-details-section adu-details-full">
                          <h4>💼 Все балансы</h4>
                          <div className="adu-balances-mini">
                            {userDetails.all_balances.map(bal => (
                              <div key={bal.brand_id} className="adu-balance-row">
                                <span>{bal.logo_emoji} {bal.brand_name}</span>
                                <strong>{parseFloat(bal.amount).toFixed(2)} DAR</strong>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="adu-loading">Загрузка...</div>
                  )}
                </div>
                <div className="adu-modal-footer">
                  <button className="adu-modal-btn-cancel" onClick={closeModal}>Закрыть</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDaryUsers;